import { render, staticRenderFns } from "./moreorder.vue?vue&type=template&id=7cbf35e4&scoped=true&"
import script from "./moreorder.vue?vue&type=script&lang=js&"
export * from "./moreorder.vue?vue&type=script&lang=js&"
import style0 from "./moreorder.vue?vue&type=style&index=0&id=7cbf35e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbf35e4",
  null
  
)

export default component.exports